import React, { useMemo } from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { HomeOfficeRatio } from "../../Dashboard/dashboard.component";
import { dashboard2WfhChipSx } from "../dashboard2.styles";

type Dashboard2WfhChipProps = {
  homeOfficeRatio: HomeOfficeRatio;
};

export const Dashboard2WfhChip: React.FC<Dashboard2WfhChipProps> = ({ homeOfficeRatio }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const remainingHours = Math.max(
    0,
    homeOfficeRatio.minMobileWorkingBookingHours - homeOfficeRatio.mobileWorkingBookingHours
  );

  const color = useMemo(() => {
    const ratio =
      (homeOfficeRatio.minMobileWorkingBookingHours - homeOfficeRatio.mobileWorkingBookingHours) /
      homeOfficeRatio.minWeeklyBookingHours;

    if (ratio === 0) {
      return theme.palette.success.main;
    }

    if (ratio === 1) {
      return theme.palette.error.main;
    }

    return theme.palette.warning.main;
  }, [
    homeOfficeRatio,
    theme.palette.error.main,
    theme.palette.success.main,
    theme.palette.warning.main
  ]);

  return (
    <Box sx={dashboard2WfhChipSx(color)} data-testid="dashboard2-wfh-chip">
      {t("_dashboard2_wfhRemainingThisWeek", { hours: remainingHours })}
    </Box>
  );
};
